import React, { Component } from 'react';
import classnames from 'classnames';
import Style from './version-item.less';
import { fullDateFormat } from '@editor/src/js/utils/timeUtils';
import i18n from '@i18next/i18n';
import { getMultUrl } from '@tencent/tencent_doc_open_url';
import { fileTypes, recordTypes } from './constant';
import { OnlineEditServices } from '@src/slide/domain/slide-app/scenes/online/core/online-edit-services.core';
import { openUrlForAll } from '@src/slide/infrastructure/module/independent/url/open-url';

const {
    MAKE_A_COPY,
    EXPORT_TO_LOCAL,
    LIFE_GROWTH_CHART,
    SAVE_AS_MY_TEMPLATE,
    PRINT_A_DOCUMENT,
    COPY_FULL_TEXT,
    IMPORT_DOCUMENTS,
    NEW_DOCUMENT,
    IMPORT_THROUGH_DRIVE,
    REPLICA_CREATION,
    TEMPLATE_CREATION,
    EXPORT_TO_DRIVE,
} = recordTypes;

const {
    UNKNOWN,
    PPT,
    WORD,
    EXCEL,
    TXT,
    PDF,
} = fileTypes;

export default class VersionItem extends Component<any, any> {
    private recordTypes;
    private fileTypeMap;

    public constructor(props) {
        super(props);
        this.state = {
            hover: false,
        };
        this.recordTypes = [
            MAKE_A_COPY,
            EXPORT_TO_LOCAL,
            EXPORT_TO_LOCAL,
            SAVE_AS_MY_TEMPLATE,
            PRINT_A_DOCUMENT,
            COPY_FULL_TEXT,
            IMPORT_DOCUMENTS,
            NEW_DOCUMENT,
            IMPORT_THROUGH_DRIVE,
            REPLICA_CREATION,
            TEMPLATE_CREATION,
            EXPORT_TO_DRIVE,
        ];
        this.fileTypeMap = {
            [UNKNOWN]: '', // unknown 保留字段
            [PPT]: i18n.t('PPT文稿'),
            [WORD]: i18n.t('Word文档'),
            [EXCEL]: i18n.t('Excel工作表'),
            [TXT]: i18n.t('TXT文件'),
            [PDF]: i18n.t('PDF文件'),
        };
    }

    public render() {
        const { item } = this.props;
        const { time, fileType, recordType } = item;
        const color = this.props.getColor(item.creator);
        const revision = OnlineEditServices.CollaborationManager()?.getRevision()
            .getRevisionNumber();
        return (
            this.recordTypes.includes(recordType) ? (
                <div className={classnames(Style['version-item-wrapper'], this.props.selected ? Style.selected : null)} onClick={this.onItemClick.bind(this)} onMouseOver={this.handleMouseOver.bind(this)} onMouseLeave={this.handleMouseLeave.bind(this)}>
                    <div className={Style['version-item-time']}>
                        {fullDateFormat(new Date(time))}
                    </div>
                    {(this.props.selected || this.state.hover) && (revision !== item.rev)
                        ? <div className={Style.revert} onClick={this.onRevertButtonClick.bind(this)}>
                            <div className={Style['revert-icon']}></div>
                            <div className={Style['revert-text']}>{i18n.t('还原')}</div>
                        </div> : null}
                    <div className={Style['version-item-content']}>
                        <div className={Style['version-item-dot']} style={{ backgroundColor: color }} />
                        <div className={Style['version-item-context']}>
                            {this.getCreator()} {this.getContext(recordType, fileType)}
                        </div>
                    </div>
                </div>
            ) : <div></div>
        );
    }

    private getFileType(fileType) {
        return this.fileTypeMap[fileType] || i18n.t('文档');
    }

    private getContext(recordType, fileType = '') {
        const context = {
            [MAKE_A_COPY]: [i18n.t('生成一份'), this.createALabel(i18n.t('副本'))],
            [EXPORT_TO_LOCAL]: [i18n.t('导出一份'), this.getFileType(fileType), i18n.t('到本地')],
            [LIFE_GROWTH_CHART]: [i18n.t('生成一张图片')],
            [SAVE_AS_MY_TEMPLATE]: [i18n.t('将此文档保存为模板')],
            [PRINT_A_DOCUMENT]: [i18n.t('打印此文档')],
            [IMPORT_DOCUMENTS]: [i18n.t('通过导入一份'), this.getFileType(fileType), i18n.t('创建此文档')],
            [NEW_DOCUMENT]: [i18n.t('创建此文档')],
            [IMPORT_THROUGH_DRIVE]: [i18n.t('通过导入一份'), this.createALabel(this.getFileType(fileType)), i18n.t('创建此文档')],
            [REPLICA_CREATION]: [i18n.t('创建此文档')],
            [TEMPLATE_CREATION]: [i18n.t('通过'), this.createALabel(i18n.t('模板')), i18n.t('创建此文档')],
            [EXPORT_TO_DRIVE]: [i18n.t('导出一份'), this.createALabel(this.getFileType(fileType))],
        }[recordType];

        return context;
    }

    private getCreator() {
        const { creator } = this.props;

        if (creator && creator.length > 7) {
            return `${creator.substr(0, 7)}...`;
        }

        return creator;
    }

    private createALabel(text) {
        return <span key={text} className={Style['version-item-link']} onClick={() => {
            openUrlForAll({
                url: getMultUrl(`${this.props.item.url}`),
            });
        }}>{text}</span>;
    }

    private handleMouseOver() {
        this.setState({
            hover: true,
        });
    }

    private handleMouseLeave() {
        this.setState({
            hover: false,
        });
    }

    private onItemClick() {
        this.props.onItemClick?.();
    }

    private onRevertButtonClick(event) {
        this.props.onItemRevertClick?.();
        event.stopPropagation();
    }
}
